export default "__VITE_ASSET__DsrBxQYy__"